/* eslint-disable react/no-danger */
/* eslint-disable react/prop-types */
import { useModal } from '@ebay/nice-modal-react';
import { Flex, Typography } from 'antd';
import AICard from 'Components/AICard/AICard';
import { ChevronRight } from 'lucide-react';
import { parse } from 'marked';
import { useEffect } from 'react';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'Redux/reducer';
import { updateShowAiCheckerTooltip } from 'Redux/modules/ui/actions';
import AttachmentsView from 'Modules/AttachmentsView/AttachmentsView';

import useCheckHealthSummary from '../hooks/useCheckHealthSummary';
import useCalcualatorAIScore from '../hooks/useCalcualatorAIScore';

import EvaluationModal from './Evaluation/EvaluationModal';
import Header from './Header';

const TextView = ({ title, desc }) => {
  return (
    <Flex gap={4} vertical>
      <Typography.Text type="secondary" style={{ fontSize: 12 }}>
        {title}
      </Typography.Text>
      <div
        style={{ wordWrap: 'break-word' }}
        dangerouslySetInnerHTML={{ __html: desc ? (parse(desc) as string) : '---' }}
      />
    </Flex>
  );
};

const LoadingText = () => (
  <Flex vertical gap={0}>
    <Typography.Title level={5} style={{ margin: 0 }}>
      Evaluation in progress...
    </Typography.Title>
    <Typography.Text>No need to wait, feel free to finish your consult.</Typography.Text>
  </Flex>
);

const ConsultSummary = ({ doctor, consult, summary }) => {
  const {
    title,
    clinicalNotes,
    summary: diagnosis,
    plan,
    followUpDate,
    privateNote,
    attachments,
  } = summary;

  const evaluationModal = useModal(EvaluationModal);

  const {
    data: { enableAiChecker },
  } = useSelector((state: RootState) => state.webChat.doctor);

  const { data, isLoading } = useCheckHealthSummary();

  const handleClick = () => {
    evaluationModal.show({
      doctor,
      consult,
    });
  };

  const { isShowAiCheckerTooltip } = useSelector((state: RootState) => state.ui);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(updateShowAiCheckerTooltip(true));
  }, [dispatch]);

  const { quality } = useCalcualatorAIScore(data?.score ?? null);

  return (
    <Flex gap={12} vertical style={{ marginBottom: 16 }}>
      <div onClick={handleClick} style={{ cursor: 'pointer' }}>
        {enableAiChecker && (
          <AICard
            header={
              <Header
                title={<Typography.Text strong>AI Checker</Typography.Text>}
                isLoading={isLoading}
                icon={<ChevronRight />}
                openTooltip={!isShowAiCheckerTooltip}
              />
            }
            content={
              isLoading ? (
                <LoadingText />
              ) : (
                <Flex vertical gap={0}>
                  <Typography.Title level={5} style={{ margin: 0 }}>
                    Overall Score
                  </Typography.Title>
                  <Typography.Text>
                    {data?.score} - {quality}
                  </Typography.Text>
                </Flex>
              )
            }
          />
        )}
      </div>
      <Flex gap={8} vertical>
        <TextView title="Title" desc={title} />
        <TextView title="Clinical Notes" desc={clinicalNotes} />
        <TextView title="Diagnosis" desc={diagnosis} />
        <TextView title="Plan" desc={plan} />
        <TextView
          title="Follow up visit"
          desc={followUpDate ? moment(followUpDate).format('MMM DD, YYYY') : '---'}
        />
        <TextView title="Note" desc={privateNote} />
        <AttachmentsView attachments={attachments ?? []} />
      </Flex>
    </Flex>
  );
};

export default ConsultSummary;
